import { render, staticRenderFns } from "./StaffListPage.vue?vue&type=template&id=7c23268c&scoped=true"
import script from "./StaffListPage.vue?vue&type=script&lang=js"
export * from "./StaffListPage.vue?vue&type=script&lang=js"
import style0 from "./StaffListPage.vue?vue&type=style&index=0&id=7c23268c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c23268c",
  null
  
)

export default component.exports